import React from 'react';
import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Link from 'next/link';
import { Rutas } from '@/constants/rutas';
import { usePrismaContext } from '../../context/PrismaContext';

const DesktopMenu = ({ currentCategory, categories }) => {
    const theme = useTheme();
    const { getCategoryName } = usePrismaContext();

    return (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {categories.map(({ id }) => {
                const isActive = currentCategory === id;

                return (
                    <Link href={Rutas.PRISMA_CATEGORIA(id)} key={id}>
                        <Button
                            variant={isActive ? 'contained' : 'text'}
                            size="small"
                            sx={{
                                color: isActive ? theme.palette.primary.contrastText : 'white',
                                bgcolor: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                            }}
                        >
                            {getCategoryName(id)}
                        </Button>
                    </Link>
                );
            })}
        </Box>
    );
};

export default DesktopMenu;
